import React from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import { LinkText } from 'shared/Link';
import { paths } from 'client/shared/Paths';
import { ButtonPrimary } from '@spotify-internal/encore-web';
import { useT } from 'client/i18n/hooks/useT';

type MusicNotAllowedErrorModalProps = {
  onDismiss: () => void;
};

export function MusicNotAllowedErrorModal({
  onDismiss,
}: MusicNotAllowedErrorModalProps): React.ReactElement {
  const t = useT();
  return (
    <Modal
      isShowing
      isShowingCloseButton
      onClose={onDismiss}
      aria-labelledby="music-not-allowed-error-modal-title"
    >
      <Modal.Title id="music-not-allowed-error-modal-title">
        {t(
          'EpisodeEditorPublish.MusicNotAllowedErrorModal.Title',
          'Unable to publish',
          'Music not allowed in episode error modal title'
        )}
      </Modal.Title>
      <Modal.Body>
        <div>
          {t(
            'EpisodeEditorPublish.MusicNotAllowedErrorModal.Message',
            "We're having trouble publishing your episode. For more information reach out to us at {helpPageLink}",
            'Music not allowed in episode error modal message',
            {
              helpPageLink: (
                <LinkText
                  isInline
                  target="_blank"
                  to={paths.getHelpPage('home')}
                >
                  {paths.getHelpPage('home')}
                </LinkText>
              ),
            }
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <ButtonPrimary onClick={onDismiss}>
          {t('Button.GotIt', 'Got it', 'Dismiss button text')}
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
}
